import { render } from "./Vocabulary.vue?vue&type=template&id=43c8ebbe&scoped=true"
import script from "./Vocabulary.vue?vue&type=script&lang=js"
export * from "./Vocabulary.vue?vue&type=script&lang=js"

import "./Vocabulary.vue?vue&type=style&index=0&id=43c8ebbe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-43c8ebbe"

export default script